

import actionTypes from '../actionTypes';

const flagsInitial = {
  tournamentCasinoRegisterFormIsLoading: false,
  tournamentCasinoRegisterIsSuccessfull: false,
  tournamentCasinoUnregisterFormIsLoading: false,
  tournamentCasinoUnregisterIsSuccessfull: false,
};

export const flags = (state = flagsInitial, action) => {
  switch (action.type) {
    case actionTypes.TOURNAMENT_CASINO_REGISTER_REQUEST: {
      return {...state, tournamentCasinoRegisterFormIsLoading: true , tournamentCasinoRegisterIsSuccessfull: false }
    } case actionTypes.TOURNAMENT_CASINO_REGISTER_SUCCESS: {
      return { ...state, tournamentCasinoRegisterFormIsLoading: false, tournamentCasinoRegisterIsSuccessfull: true };
    } case actionTypes.TOURNAMENT_CASINO_REGISTER_FAIL: {
      return { ...state, tournamentCasinoRegisterFormIsLoading: false, tournamentCasinoRegisterIsSuccessfull: false };
    } case actionTypes.TOURNAMENT_CASINO_REGISTER_SUCCESS_RESET: {
      return { ...state, tournamentCasinoRegisterIsSuccessfull: false };
    } case actionTypes.TOURNAMENT_CASINO_UNREGISTER_REQUEST: {
      return { ...state, tournamentCasinoUnregisterFormIsLoading: true, tournamentCasinoUnregisterIsSuccessfull: false };
    } case actionTypes.TOURNAMENT_CASINO_UNREGISTER_SUCCESS: {
      return { ...state, tournamentCasinoUnregisterFormIsLoading: true, tournamentCasinoUnregisterIsSuccessfull: true };
    } case actionTypes.TOURNAMENT_CASINO_UNREGISTER_FAIL: {
      return { ...state, tournamentCasinoUnregisterFormIsLoading: false, tournamentCasinoUnregisterIsSuccessfull: false };
    } case actionTypes.TOURNAMENT_CASINO_UNREGISTER_SUCCESS_RESET: {
      return { ...state, tournamentUnregisterIsSuccessful: false , tournamentCasinoUnregisterIsSuccessfull: false};
    }
      
    default: {
      return state;
    }
  }
}

